import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MenuServiceService } from './menu-service.service';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CargoService } from 'src/app/core/services/cargo.service';
import { Utils } from 'src/app/core/resources/utils';
import { CargoDetailService } from '../../cargo/cargo-detail/cargo-detail.service';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { CargoStateDict } from 'src/app/core/enums/cargoState.enum';
import { Subscription } from 'rxjs';
import { Fmt } from 'src/app/core/messages/fmt';
import { ServiceResources } from '../resources/services';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { ConsignmentCargo } from 'src/app/core/interfaces/consignmentCargo';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { VehiclesService } from '../../administration/vehicles/list-vehicles.service';
@Component({
  selector: 'app-menu-service',
  templateUrl: './menu-service.component.html',
  styleUrls: ['./menu-service.component.scss']
})
export class MenuServiceComponent implements OnInit, OnDestroy {
  cargo: Cargo;
  cargoChangesSub: Subscription;
  routerEventsSub: Subscription;
  showMenu: boolean = false;
  formSubscription: Subscription;
  stepsObject = [];
  steps: string[] = Object.values(this.serviceResources.serviceRequestUrls).map(url => url.split('/').pop());
  consignmentsSubscription: Subscription;
  listenerId: string = '';
  stepLoadingStates: { [stepTitle: string]: boolean } = {};
  constructor(
    public menuService: MenuServiceService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private serviceResources: ServiceResources,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private _cargoService: CargoService,
    public utils: Utils,
    private cargoDetailService: CargoDetailService,
    private cargoManager: CargoManager,
    private dialog: MatDialog,
    private vehiclesService: VehiclesService
  ) { }

  ngOnInit() {
    this.initSubscriptions();
    this.initCargo();
    this.initRouterEvents();
  }

  private async initCargo() {
    const params = this.route.snapshot.params;
    this.listenerId = '';
    this.spinner.show();
    let initialCargo: Cargo;
    try { initialCargo = await this.getCargo(params.consecutive) } catch (error) { }
    this.spinner.hide();
    if (!initialCargo) {
      this.snackBarService.openSnackBar(`Ocurrió un error intentando traer el detalle del servicio`, undefined, "alert");
      this.goToList();
      return;
    }
    if (this.validateCargoState(initialCargo)) return;
    this.setCargo(initialCargo, false);
    await this.setCargoConsignments(initialCargo);
    await this.setCargoVehicle(initialCargo);
    const { id, eventEmitter } = this._cargoService.watch(this.cargo.id);
    this.listenerId = id;
    this.cargoChangesSub = eventEmitter.subscribe(async (cargo: Cargo) => {
      if (!cargo || (cargo && this.cargo && cargo.id !== this.cargo.id)) return;
      if (this.validateCargoState(cargo)) return;
      this.setLoadingStep('Manifiesto y remesas', true);
      this.setLoadingStep('Publicación', true);
      this.setLoadingStep(`Vehículo ${this.menuService.isEscortedService() ? ' del escolta' : ''}`, true);
      try {
        this.setCargo(cargo, true);
        await this.setCargoConsignments(cargo);
        await this.setCargoVehicle(cargo);
      } catch (error) {
        console.error('Error in consigments and vehicle details: ', error);
      } finally {
        this.setLoadingStep('Manifiesto y remesas', false);
        this.setLoadingStep('Publicación', false);
        this.setLoadingStep(`Vehículo ${this.menuService.isEscortedService() ? ' del escolta' : ''}`, false);
      }
    }, console.error);

    if (!this.currentStep || !this.steps.includes(this.currentStep))
      this.setRoute(this.serviceResources.serviceRequestUrls.contractor);
  }

  async onRefreshCargo(consecutive: string) {
    this.spinner.show();
    let initialCargo: Cargo;
    try { initialCargo = await this.getCargo(consecutive) } catch (error) { }
    this.spinner.hide();
    if (!initialCargo) return this.snackBarService.openSnackBar(`Ocurrió un error intentando traer el detalle del servicio`, undefined, "alert");
    if (this.validateCargoState(initialCargo)) return;
    this.setCargo(initialCargo, !!this.menuService.isListeningChangesFromFirebase);
    await this.setCargoConsignments(initialCargo);
    await this.setCargoVehicle(initialCargo);
  }

  private setLoadingStep(step: string, state: boolean) {
    this.stepLoadingStates[step] = state;
  }

  public getStepLoadingState(stepTitle: string): boolean {
    return this.stepLoadingStates[stepTitle] || false;
  }

  private initRouterEvents() {
    this.routerEventsSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event && event.url) {
        if (event.url == `/service-request-form/menu-service/${this.cargo.consecutive}`)
          return history.back();
        const currentUrl = event.url.split('/').pop();
        if (!currentUrl || !this.steps.includes(currentUrl))
          this.setRoute(this.serviceResources.serviceRequestUrls.contractor);
      }
    });
  }

  private initSubscriptions() {
    this.formSubscription = this.menuService.formObservable.subscribe(() => this.setStepsObject());
    this.consignmentsSubscription = this.menuService.consignmentsObservable.subscribe(() => this.setStepsObject());
  }

  private setStepsObject() {
    this.stepsObject = [
      {
        routeName: this.serviceResources.serviceRequestUrls.contractor.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.contractor,
        isRequired: true,
        isValid: this.menuService.isValidContractorTripInfo(),
        title: 'Contratante del servicio',
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidTripType(),
            title: 'Tipo de viaje',
          },
          {
            isRequired: this.menuService.isRequiredMinistry(),
            isValid: this.menuService.isValidMinistry(),
            title: 'Requerimiento de manifiesto',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidCargoOwnerName(),
            title: 'Nombre del contratante',
          },
          {
            isRequired: this.menuService.isRequiredCargoOwnerBranchOffice(),
            isValid: this.menuService.isValidCargoOwnerBranchOffice(),
            title: 'Dirección del contratante',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Código identificador',
          },
          {
            isRequired: this.menuService.isRequiredCargoTags(),
            isValid: { isValid: true },
            title: 'Etiquetas',
          }
        ],
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.origin.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.origin,
        isRequired: true,
        isValid: this.menuService.isValidOrigin(),
        title: 'Origen del servicio',
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidOriginCity(),
            title: 'Ciudad de origen',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidDateLoad(),
            title: 'Fecha estimada',
          },
          {
            isRequired: this.menuService.isRequiredReteica(),
            isValid: this.menuService.isValidReteica(),
            title: 'ReteIca',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidOriginAddresses(),
            title: 'Direcciones de origen',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.destination.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.destination,
        isRequired: true,
        isValid: this.menuService.isValidDestination(),
        title: 'Destino del servicio',
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidDestinationCities(),
            title: 'Ciudad de destino',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidDestinationAddresses(),
            title: 'Direcciones de destino',
          },
          {
            isRequired: this.menuService.isTransportService(),
            isValid: { isValid: true },
            title: 'Guías',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.vehicle.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.vehicle,
        isRequired: this.menuService.isEscortedService() || this.menuService.isTransportService(),
        isValid: this.menuService.isValidVehicleTypeInfo(),
        title: `Vehículo ${this.menuService.isEscortedService() ? ' del escolta' : ''}`,
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidVehicleType(),
            title: 'Tipo de vehículo',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidVehicleTypeBodyWorkType(),
            title: 'Tipo de carrocería',
          },
          {
            isRequired: this.menuService.isRequiredEnvironmentType(),
            isValid: this.menuService.isValidEnvironmentType(),
            title: 'Tipo de ambiente',
          },
          {
            isRequired: this.menuService.isRequiredVehicleAxles(),
            isValid: this.menuService.isValidVehicleAxles(),
            title: 'Número de ejes',
          },
          {
            isRequired: this.menuService.isRequiredTrailer(),
            isValid: this.menuService.isValidTrailer(),
            title: 'Tráiler',
          },
          {
            isRequired: this.menuService.isRequiredTrailer(),
            isValid: this.menuService.isValidTrailerAxles(),
            title: 'Número de ejes del tráiler',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.escortedVehicle.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.escortedVehicle,
        isRequired: this.menuService.isEscortedService() || this.menuService.isSatelliteLockService(),
        isValid: this.menuService.isValidEscortedVehicle(),
        title: `Vehículo ${this.menuService.isSatelliteLockService() ? ' a seguir' : ' y conductor a escoltar'}`,
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidEscortedLicensePlate(),
            title: `Placa del vehículo a ${this.menuService.isSatelliteLockService() ? 'seguir' : 'escoltar'}`,
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Tipo de vehículo',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'N° de contenedor',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Marca del vehículo',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Color del vehículo',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Tipo de identificación del conductor',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Documento del conductor',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidEscortedDriverName(),
            title: 'Nombre del conductor',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidEscortedPhoneNumber(),
            title: 'Celular del conductor',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.cargoType.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.cargoType,
        isRequired: this.menuService.isRequiredLoadTypeService(),
        isValid: this.menuService.isValidLoadTypeService(),
        title: 'Tipo de servicio',
        subSteps: [
          {
            isRequired: this.menuService.isRequiredLetterRetirement(),
            isValid: this.menuService.isValidLetterRetirement(),
            title: 'Carta de retiro',
          },
          {
            isRequired: this.menuService.isRequiredRegimeType(),
            isValid: this.menuService.isValidRegimeType(),
            title: 'Tipo de régimen',
          },
          {
            isRequired: this.menuService.isRequiredDateVesselArrival(),
            isValid: this.menuService.isValidDateVesselArrival(),
            title: 'Fecha de descargue del buque',
          },
          {
            isRequired: this.menuService.isRequiredLoadType(),
            isValid: this.menuService.isValidLoadType(),
            title: 'Tipo de carga',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidServiceType(),
            title: 'Tipo de servicio',
          },
          {
            isRequired: this.menuService.isRequiredContainerSize(),
            isValid: this.menuService.isValidContainerSize(),
            title: 'Medida del contenedor',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.loadCharacteristics.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.loadCharacteristics,
        isRequired: true,
        isValid: this.menuService.isValidLoadCharacteristics(),
        title: 'Características del servicio',
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidRiskProfile(),
            title: 'Perfil de riesgo',
          },
          {
            isRequired: this.menuService.isRequiredContainerInfo(),
            isValid: this.menuService.isValidContainerInfo(),
            title: 'Datos del contenedor',
          },
          {
            isRequired: this.menuService.isRequiredMerchandiseCharacteristics(),
            isValid: this.menuService.isValidAmount(),
            title: 'Valor declarado de la mercancía',
          },
          {
            isRequired: this.menuService.isRequiredMerchandiseCharacteristics(),
            isValid: this.menuService.isValidTotalMeasurement(),
            title: 'Medida total',
          },
          {
            isRequired: this.menuService.isRequiredMerchandiseCharacteristics(),
            isValid: this.menuService.isValidQuantity(),
            title: 'Cantidad de unidades',
          },
          {
            isRequired: this.menuService.isRequiredMerchandiseCharacteristics(),
            isValid: this.menuService.isValidTotalWeight(),
            title: 'Peso total de la mercancía',
          },
          {
            isRequired: this.menuService.isRequiredMerchandiseCharacteristics(),
            isValid: this.menuService.isValidUnit(),
            title: 'Unidad de medida',
          },
          {
            isRequired: this.menuService.isRequiredMerchandiseCharacteristics(),
            isValid: this.menuService.isValidType(),
            title: 'Tipo de almacenamiento',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.satelliteLockService.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.satelliteLockService,
        isRequired: this.menuService.isSatelliteLockService(),
        isValid: this.menuService.isValidSatelliteLock(),
        title: 'Candado Satelital',
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidSatelliteLock(),
            title: 'Tipo de candado satelital',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.additionalValuesService.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.additionalValuesService,
        isRequired: true,
        isValid: this.menuService.isValidServiceValue(),
        title: 'Valor del servicio',
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidServiceRate(),
            title: 'Valor de la tarifa',
          },
          {
            isRequired: !this.menuService.isSatelliteLockService(),
            isValid: this.menuService.isValidFreightCost(),
            title: 'Valor del flete',
          },
          {
            isRequired: !this.menuService.isSatelliteLockService(),
            isValid: this.menuService.isValidAdvancePercentage(),
            title: 'Porcentaje de anticipo',
          },
          {
            isRequired: !this.menuService.isSatelliteLockService(),
            isValid: this.menuService.isValidPaymentTime(),
            title: 'Tiempo de pago del saldo',
          },
          {
            isRequired: this.menuService.isRequiredAdditionalServices(),
            isValid: { isValid: true },
            title: 'Servicios adicionales',
          },
          {
            isRequired: this.menuService.isRequiredTravelExpenses(),
            isValid: { isValid: true },
            title: 'Viáticos',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.observationsService.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.observationsService,
        isRequired: true,
        isValid: { isValid: true },
        title: 'Observaciones',
        subSteps: [
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Observaciones internas',
          },
          {
            isRequired: this.menuService.isEscortedService() || this.menuService.isTransportService(),
            isValid: { isValid: true },
            title: `Requisitos ${this.menuService.isEscortedService() ? ' para el escolta' : ' adicionales del conductor'}`,
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.consignmentsService.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.consignmentsService,
        isRequired: this.menuService.isRequiredConsignmentsService(),
        isValid: this.menuService.isValidConsignmentsService(),
        title: 'Manifiesto y remesas',
        subSteps: [
          {
            isRequired: true,
            isValid: this.menuService.isValidManifestType(),
            title: 'Tipo de manifiesto',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Tipo de operación',
          },
          {
            isRequired: true,
            isValid: { isValid: true },
            title: 'Empresa de monitoreo',
          },
          {
            isRequired: true,
            isValid: this.menuService.isValidConsignments(),
            title: 'Remesas',
          }
        ]
      },
      {
        routeName: this.serviceResources.serviceRequestUrls.servicePublication.split('/').pop(),
        routeUrl: this.serviceResources.serviceRequestUrls.servicePublication,
        isRequired: true,
        isValid: this.menuService.isValidServicePublication(),
        title: 'Publicación',
        subSteps: []
      }
    ];
  }

  get currentStep(): string {
    const currentStep = this.router.url.split('/').pop();
    return currentStep && this.steps.includes(currentStep) ? currentStep : '';
  }

  private getCargo(consecutive: string): Promise<Cargo> {
    return this.cargoDetailService.detailCargoByConsecutive(consecutive).toPromise();
  }

  private validateCargoState(cargo: Cargo) {
    const { redirect, path } = this.cargoManager.checkRedirectCargo(cargo, 'menu-service');
    if (redirect) {
      this.showAlertChangeState(cargo);
      this.router.navigate([path]);
    }
    return redirect;
  }

  private showAlertChangeState(cargo: Cargo) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `El servicio ${cargo.consecutive} ha sido actualizado`,
      iconAlert: true,
      description: `El servicio ha pasado al estado de ${CargoStateDict[cargo.state] ? CargoStateDict[cargo.state].toLowerCase() : cargo.state}, se te redirigirá a la visual correspondiente`,
      hideBtnCancel: false,
      hideBtnConfirm: true,
    };
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  private setCargo(cargo: Cargo, changesFromFirebase: boolean = true) {
    this.cargo = cargo;
    this.menuService.cargo = this.cargo;
    this.menuService.patchForm(this.cargo, changesFromFirebase);
  }

  private async setCargoConsignments(cargo: Cargo) {
    if (!cargo || !cargo.ministry) {
      this.menuService.cargoConsignments = [];
      return;
    }
    let consignments: ConsignmentCargo[] = [];
    try { consignments = await this.cargoDetailService.getCargoConsignments(cargo.id, 'Created').toPromise() } catch (error) { }
    this.menuService.cargoConsignments = consignments && consignments.length ? consignments : [];
  }

  private async setCargoVehicle(cargo: Cargo) {
    if (!cargo || !cargo.licensePlate) {
      this.menuService.cargoVehicle = null;
      return;
    }
    if (this.menuService.cargoVehicle && this.menuService.cargoVehicle.id === cargo.licensePlate) return;
    let vehicle: Vehicle;
    try { vehicle = await this.vehiclesService.getVehicleFromOwnCompany(cargo.licensePlate).toPromise() } catch (error) { }
    this.menuService.cargoVehicle = vehicle;
  }

  /**
  * This method allows to go to an specific list of elements based on the path that pass it in the parameters.
  * @param {string} routeUrl (string - optional) is the path needed to redirect
  * @param {NavigationExtras} params (NavigationExtras - optional) extra parameters needed in the router navigate
  */
  private goToList(routeUrl?: string, params?: NavigationExtras) {
    if (routeUrl) {
      if (params) this.router.navigate([routeUrl, params]);
      else this.router.navigate([routeUrl]);
    }
    else this.router.navigate(["cargo/list/request"]);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  /**
   * @description Sets the route based on step number and validates progress
   * @param typeStep Type of step
   * @param step Step number
   */
  setRoute(url: string) {
    this.showMenu = false;
    this.router.navigate([Fmt.string(url, this.cargo.consecutive)]);
  }

  ngOnDestroy() {
    if (this.cargoChangesSub) this.cargoChangesSub.unsubscribe();
    if (this.routerEventsSub) this.routerEventsSub.unsubscribe();
    if (this.formSubscription) this.formSubscription.unsubscribe();
    if (this.consignmentsSubscription) this.consignmentsSubscription.unsubscribe();
    this._cargoService.stopWatch(this.listenerId);
  }
}
